import { Card } from '../../../../components/ui/card';
import { Skeleton } from '../../../../components/ui/skeleton';
import { Separator } from '../../../../components/ui/separator';

export const CardAddressSkelton = () => {
  return (
    <Card className="flex flex-col space-y-4 pl-4 pt-4 pb-4 rounded-2xl">
      {[1, 2, 3, 4].map((_, index) => (
        <div key={index}>
          <div className="flex flex-row items-start justify-between pb-4">
            <div className="flex flex-col space-y-1">
              <Skeleton className="h-2 w-10" />
              <Skeleton className="h-2 w-20" />
            </div>
            <Skeleton className="text-body-sm-regular h-3 w-10 mr-4" />
          </div>
          {index !== [1, 2, 3, 4].length - 1 && <Separator />}
        </div>
      ))}
    </Card>
  );
};
